import {Fragment, useCallback, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {ExclamationCircleIcon} from '@heroicons/react/solid'
import axios from "axios";
import {useRouter} from "next/router";
import {getVersionOnce} from "@/services/version-store";
import {useAuth} from "@/libs/auth";
import {updateModel} from "@/services/models-store";
import {log} from '@/libs/analytics-logging';


const validate = (values: any) => {
  const errors: any = {};
  if (!values.name) {
    errors.name = 'Model Name is Required';
  }
  if (!values.description) {
    errors.description = 'Model Description is Required';
  }
  return errors;
};

const StopContainerModal = (props: { open: boolean, close: any, deployedVersion: any }) => {
  const router = useRouter();
  const {projectId, modelId} = router.query;
  console.log(props.open)

  const closeModal = useCallback(() => {
    props.close();
  }, [props])

  const {token} = useAuth()

  const stopDeployment = useCallback(() => {
    console.log('deployment stopping')
    let dataReq = {
      projectId: projectId,
      modelId: modelId
    }
    axios({
      method: 'post',
      url: 'https://deploy.blankly.finance/model/kill',
      headers: {token: token},
      data: dataReq
    }).then(() => {
      log('Model Stopped');
      updateModel(projectId as string, modelId as string, {
        deployedVersion: "",
        lifecycleStatus: {endAt: Date.now() / 1000, running: false, message: "Exited"}
      });
      console.log('deployment stopped')
    }).catch(() => {
      log('Model Stop Failed', dataReq)
    })
    closeModal()
  }, [closeModal, modelId, projectId, token]);

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={closeModal}>
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className="inline-block align-bottom bg-white rounded-lg px-8 pt-5 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                </div>
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                    Are You Sure You Want to Stop Your Model
                  </Dialog.Title>
                  <div>
                    <p className="text-sm text-gray-500">
                      This action cannot be reversed
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-12">
                <button
                  onClick={stopDeployment}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Stop Container
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default StopContainerModal;
